interface Legend {
  [key: string]: {
    color: string
    value: number | string
  }[]
}

export const getLegends = (t: (key: string) => string): Legend => {
  return {
    total_employment: [
      {
        color: '#C5D564',
        value: '0-60',
      },
      {
        color: '#DAD14C',
        value: '61-130',
      },
      {
        color: '#EECD34',
        value: '130-199',
      },
      {
        color: '#FCC423',
        value: '200-299',
      },
      {
        color: '#F9891A',
        value: '301-399',
      },
      {
        color: '#F14C11',
        value: '>= 400',
      },
    ],
    total_establishments: [
      {
        color: '#C5D564',
        value: '0-20',
      },
      {
        color: '#DAD14C',
        value: '21-40',
      },
      {
        color: '#EECD34',
        value: '41-60',
      },
      {
        color: '#FCC423',
        value: '61-80',
      },
      {
        color: '#F9891A',
        value: '81-100',
      },
      {
        color: '#F14C11',
        value: '>= 100',
      },
    ],

    total_employment_most_represented_sector: [
      {
        color: '#C5D564',
        value: t('common.company_sector_1'),
      },
      {
        color: '#EECD34',
        value: t('common.company_sector_2'),
      },
      {
        color: '#F9891A',
        value: t('common.company_sector_3'),
      },
    ],
    total_establishments_most_represented_sector: [
      {
        color: '#C5D564',
        value: t('common.company_sector_1'),
      },
      {
        color: '#EECD34',
        value: t('common.company_sector_2'),
      },
      {
        color: '#F9891A',
        value: t('common.company_sector_3'),
      },
    ],
  }
}
